// extracted by mini-css-extract-plugin
export default {"pageTitle":"BKDjBPgXpft1PZkvPeRD"};